import React from "react";
import {StyledButton} from "../../components/index.jsx";
import "./order-actions.css";
import classnames from "classnames";
import {ConfigProvider, Dropdown, Menu, Spin} from "antd";
import {DownOutlined} from "@ant-design/icons";

export const OrderActions = ({actions, className, data}) => {
    return (
        <div className={classnames("order-actions-container", className)}>
            <ConfigProvider direction="rtl">
                {!!actions?.length && (
                    <>
                        {actions.map((option, index) => {
                            return getActionByType(option, index, data);
                        })}
                    </>
                )}
            </ConfigProvider>
        </div>
    );
};

export const getActionByType = (
    {onClick, text, disabled, icon, color, loading, className, type, options, customComponent},
    index,
    data
) => {
    const displayText = typeof text === "function" ? text(data) : text;

    switch (type) {
        case "dropdown":
            return (
                <Dropdown
                    key={index}
                    overlay={<Menu items={options} onClick={({key}) => onClick(key)} />}
                    trigger={["click"]}>
                    <StyledButton
                        className={classnames("order-actions-btn-dropdown", "order-actions-btn", color, className)}>
                        <span className="order-actions-btn-dropdown-text">{displayText}</span>
                        {!!loading && <Spin />}
                        <DownOutlined />
                    </StyledButton>
                </Dropdown>
            );
        case "custom":
            return customComponent;
        default:
            return (
                <StyledButton
                    key={index}
                    className={classnames("order-actions-btn", color, className)}
                    onClick={onClick}
                    disabled={!!disabled}
                    icon={icon}>
                    {displayText}
                    {!!loading && <Spin />}
                </StyledButton>
            );
    }
};
